module.exports = __webpack_public_path__ + "static/media/tax-breakdown.394859e6.png";